// extracted by mini-css-extract-plugin
export default {"tab":"Tab_tab__f+rWy","tabInactive":"Tab_tabInactive__veYRc","tabActive":"Tab_tabActive__pMbmo","dark":"Tab_dark__VVsgt"};